'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from 'cn';
import { useTranslations } from 'next-intl';
import { Link } from '@/components/ui/link';
import { useSpotifyStats } from '@/hooks/queries/stats.query';
type NowPlayingProps = React.ComponentProps<'div'>;
export function NowPlaying(props) {
  const $ = _c(27);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  const {
    data,
    isSuccess,
    isLoading,
    isError
  } = useSpotifyStats();
  const t = useTranslations();
  const isPlaying = isSuccess && data.isPlaying;
  const notPlaying = isSuccess && !data.isPlaying;
  let t0;
  if ($[3] !== className) {
    t0 = cn("flex items-center gap-4 text-center text-sm md:text-left", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg role="img" viewBox="0 0 24 24" fill="#1ED760" width={20} xmlns="http://www.w3.org/2000/svg"><title>Spotify</title><path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" /></svg>;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== data || $[7] !== isPlaying) {
    t2 = isPlaying && <Link href={data.songUrl}>{data.name} - {data.artist}</Link>;
    $[6] = data;
    $[7] = isPlaying;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== notPlaying || $[10] !== t) {
    t3 = notPlaying && t("layout.now-playing.not-listening");
    $[9] = notPlaying;
    $[10] = t;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== isLoading || $[13] !== t) {
    t4 = isLoading && t("layout.now-playing.loading");
    $[12] = isLoading;
    $[13] = t;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== isError || $[16] !== t) {
    t5 = isError && t("error.now-playing-error");
    $[15] = isError;
    $[16] = t;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5) {
    t6 = <p className="flex-1">{t2}{t3}{t4}{t5}</p>;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== rest || $[24] !== t0 || $[25] !== t6) {
    t7 = <div className={t0} {...rest}>{t1}{t6}</div>;
    $[23] = rest;
    $[24] = t0;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
}